import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { TASK_EMPLOYEE_AUDIT_LIST } from '../../actions';
import { TaskEmployeeAuditListSuccess, TaskEmployeeAuditListError } from '../../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
        }, reject);
    });
}

const onListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/employee_audit/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

function* onList(action) {
    try {
        const response = yield call(onListAsync, action.payload);
        yield put(TaskEmployeeAuditListSuccess(response.data.data || []));
    } catch (error) {
        yield put(TaskEmployeeAuditListError(error));
    }
}

function* watchList() { yield takeEvery(TASK_EMPLOYEE_AUDIT_LIST, onList); }

export default function* rootSaga() {
    yield all([fork(watchList)]);
}
